var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 140"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 76",
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#293D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.92262 5.1333L3.66675 6.51197L7.7461 11L3.66675 15.488L4.92262 16.8666L10.2667 11L4.92262 5.1333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.1288 5.1333L11.7334 6.51197L16.266 11L11.7334 15.488L13.1288 16.8666L19.0667 11L13.1288 5.1333Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/Next.7270d8ffe16d81fc51a960479144f4ba.svg";
export { ForwardRef as ReactComponent };